export function genId(): string {
  return (Date.now() * 100 + Math.floor(Math.random() * 100)).toString(32);
}

interface Brige {
  handlerName: string;
  resolves: {
    [id: string]: {
      resolve: (value: any) => void;
      reject: (value: any) => void;
    };
  };
}

class Brige {
  constructor(handlerName: string) {
    this.resolves = {};
    this.handlerName = handlerName;
  }
  send(type: string, payload: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const id = genId();
      this.resolves[id] = { resolve, reject };
      this.postMessage({
        type,
        id,
        payload,
      });
    });
  }
  async postMessage(message: MessageType) {
    const msg = await window.flutter_inappwebview.callHandler(this.handlerName, message);
    this.sendResponse(msg);
  }
  sendResponse(message: MessageType) {
    const p = this.resolves[message.id];
    if (p) {
      if (message.type === 'error') {
        p.reject(message.payload);
      } else {
        p.resolve(message.payload);
      }
    }
  }
}

export default Brige;
